/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const learning_unit_level_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "name",
        defaultDisplayPreferences: {
order: 1, size: 200, visible: true, displayAs: "string", pinned: true
        },
    },
    {
        id: "code",
        defaultDisplayPreferences: {
order: 2, size: 120, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
order: 3, size: 150, visible: true, displayAs: "date", pinned: false
        },
    },
];
